export default __webpack_public_path__ + "static/media/img8.8677f298.jpg";